
import { Car, Accessibility, User, Users, Award, Heart, Globe } from 'lucide-react';
import { DogSchool } from '@/data/dogSchools';

interface SchoolFeaturesProps {
  school: DogSchool;
}

export const SchoolFeatures = ({ school }: SchoolFeaturesProps) => {
  return (
    <div className="space-y-3">
      {school.features?.hasFreeParking && (
        <div className="flex items-start space-x-3">
          <Car className="h-5 w-5 text-primary mt-0.5 flex-shrink-0" />
          <span className="text-gray-600">
            Parkplätze verfügbar
          </span>
        </div>
      )}
      
      {school.features?.isWheelchairAccessible && (
        <div className="flex items-start space-x-3">
          <Accessibility className="h-5 w-5 text-primary mt-0.5 flex-shrink-0" />
          <span className="text-gray-600">
            Rollstuhlgerecht
          </span>
        </div>
      )}
      
      {school.features?.hasPrivateLessons && (
        <div className="flex items-start space-x-3">
          <User className="h-5 w-5 text-primary mt-0.5 flex-shrink-0" />
          <span className="text-gray-600">
            Einzelstunden verfügbar
          </span>
        </div>
      )}
      
      {school.features?.hasGroupLessons && (
        <div className="flex items-start space-x-3">
          <Users className="h-5 w-5 text-primary mt-0.5 flex-shrink-0" />
          <span className="text-gray-600">
            Gruppenstunden verfügbar
          </span>
        </div>
      )}
      
      {school.features?.hasDogLicense && (
        <div className="flex items-start space-x-3">
          <Award className="h-5 w-5 text-primary mt-0.5 flex-shrink-0" />
          <span className="text-gray-600">
            Hundeführerschein möglich
          </span>
        </div>
      )}
      
      {school.features?.isLGBTQFriendly && (
        <div className="flex items-start space-x-3">
          <Heart className="h-5 w-5 text-primary mt-0.5 flex-shrink-0" />
          <span className="text-gray-600">
            LGBTQ+ freundlich
          </span>
        </div>
      )}
      
      {school.features?.hasMultiLanguageSupport && (
        <div className="flex items-start space-x-3">
          <Globe className="h-5 w-5 text-primary mt-0.5 flex-shrink-0" />
          <span className="text-gray-600">
            Mehrsprachiger Unterricht
          </span>
        </div>
      )}
    </div>
  );
};
